import { createSlice } from "@reduxjs/toolkit";
import { Category } from "../../@types/Category";
import { findFileTypes } from "../fileTypes/actions/findFileTypes"
import { createFileType } from "./actions/createFileType";
import { findFileTypeById } from "./actions/findFileTypeById";
import { updateFileType } from "./actions/updateFileType";

export interface FilterFileTypes {
    name: string;
    checked: boolean;
}

interface FileTypesState {
    fileType: Category;
    fileTypesList: Category[];
    findFileTypeByIdStatus: "idle" | "pending" | "succeeded" | "failed";
    findFileTypesStatus: "idle" | "pending" | "succeeded" | "failed";
    createFileTypeStatus: "idle" | "pending" | "succeeded" | "failed";
    updateFileTypeStatus: "idle" | "pending" | "succeeded" | "failed";
    searchText: string;
    isSignableFilter: boolean;
    notSignableFilter: boolean;
    enabledFilter: boolean;
    disabledFilter: boolean;
    filterModal: boolean;
    filterList: FilterFileTypes[];
    maxListIndex: number;
};

const initialState = {
    fileType: {} as Category,
    fileTypesList: [],
    findFileTypeByIdStatus: "idle",
    findFileTypesStatus: "idle",
    createFileTypeStatus: "idle",
    updateFileTypeStatus: "idle",
    searchText: "",
    isSignableFilter: true,
    notSignableFilter: true,
    enabledFilter: true,
    disabledFilter: true,
    filterModal: false,
    filterList: [],
    maxListIndex: 20,
} as FileTypesState;


const fileTypesSlice = createSlice({
    name: "fileTypes",
    initialState,
    reducers: {
        setInitialData() {
            return initialState;
        },
        setSearchText(state, { payload }) {
            state.searchText = payload;
            state.maxListIndex = 20;
        },
        setIsSignableFilter(state, { payload }) {
            state.isSignableFilter = payload;
        },
        setNotSignableFilter(state, { payload }) {
            state.notSignableFilter = payload;
        },
        setEnabledFilter(state, { payload }) {
            state.enabledFilter = payload;
        },
        setDisabledFilter(state, { payload }) {
            state.disabledFilter = payload;
        },
        setFilterList(state, { payload }) {
            state.filterList = payload;
        },
        setFilterModal(state, { payload }) {
            state.filterModal = payload;
        },
        setMaxListIndex(state, { payload }) {
            state.maxListIndex = payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(findFileTypes.pending, (state) => {
                state.findFileTypesStatus = "pending";
            })
            .addCase(findFileTypes.fulfilled, (state, { payload }) => {
                state.findFileTypesStatus = "succeeded";
                state.fileTypesList = payload;
            })
            .addCase(findFileTypes.rejected, (state) => {
                state.findFileTypesStatus = "failed";
            })
            .addCase(createFileType.pending, (state) => {
                state.createFileTypeStatus = "pending";
            })
            .addCase(createFileType.rejected, (state) => {
                state.createFileTypeStatus = "failed";
            })
            .addCase(createFileType.fulfilled, (state) => {
                state.createFileTypeStatus = "succeeded";
            })
            .addCase(updateFileType.pending, (state) => {
                state.updateFileTypeStatus = "pending";
            })
            .addCase(updateFileType.rejected, (state) => {
                state.updateFileTypeStatus = "failed";
            })
            .addCase(updateFileType.fulfilled, (state) => {
                state.updateFileTypeStatus = "succeeded";
            })
            .addCase(findFileTypeById.pending, (state) => {
                state.findFileTypeByIdStatus = "pending";
                state.fileType = {} as Category;
            })
            .addCase(findFileTypeById.rejected, (state) => {
                state.findFileTypeByIdStatus = "failed";
                state.fileType = {} as Category;
            })
            .addCase(findFileTypeById.fulfilled, (state, { payload }) => {
                state.findFileTypeByIdStatus = "succeeded";
                state.fileType = payload;
            })
            ;
    },
});

export const {
    setInitialData,
    setSearchText,
    setMaxListIndex,
    setIsSignableFilter,
    setNotSignableFilter,
    setEnabledFilter,
    setFilterList,
    setFilterModal,
    setDisabledFilter,
} = fileTypesSlice.actions

export default fileTypesSlice.reducer